import { RequirementDefinitionTemplateForm } from "../../types";
import { CreateRequirementDefinitionIdentityVerificationPartialForm } from "../../../../../Requirements/modules/IdentityVerification/types";
import * as Yup from "yup";

type StandardIdentityVerificationValues = {};

export const STANDARD_IDENTITY_VERIFICATION_FORM: RequirementDefinitionTemplateForm<
  StandardIdentityVerificationValues,
  CreateRequirementDefinitionIdentityVerificationPartialForm
> = {
  getDefaultValues: template => ({}),
  mapFormData(values, template) {
    const data = {
      ...values,
      instructions: template.instructions!
    };

    return data;
  },
  partialForm: null,
  validationSchema: Yup.object().shape({})
};
